import { magnetar, generateRandomId } from '@/magnetarSetup.js';
import { currentUserId, userModule } from '@/store/useAuth';
import { addPage, addNote } from '../../components/ContextDoc/use/useDocActions';
import useContext from '@/views/Context/use/useContext';
// function pagesDefaults(payload) {
//   const defaults = { title: '', id: '' };
//   return { ...defaults, ...payload };
// }

export const contextsModule = magnetar.collection('contexts');
document.contextsModule = contextsModule;
// , {
//   modifyPayloadOn: { insert: payload => pagesDefaults(payload) },
//   modifyReadResponseOn: { added: payload => pagesDefaults(payload) }
// });

// export const megaContextsModule = contextsModule.where(
//   'authorIds',
//   'array-contains',
//   currentUserId.value
// );

export const subscribeToContext = async contextId => {
  console.log(contextsModule, contextId);
  const contextModule = contextsModule.doc(contextId);
  await contextModule.fetch();
  contextModule.stream();
  return;
};

export const subscribeToContexts = async () => {
  // console.log(currentUserId, userModule);
  const contextModule = contextsModule
    .where(`authors.${currentUserId.value}.id`, '==', currentUserId.value)
    .where('version', '==', 2);
  // await contextModule.fetch();
  contextModule.stream();
  return;
};

export const updateContext = ({ update, contextId = null }) => {
  const { activeContextId } = useContext();
  const cId = contextId == null ? activeContextId.value : contextId;
  contextsModule.doc(cId).merge(update);
};

export const createGroup = ({ contextId = null, name = '' }) => {
  const { activeContextId } = useContext();
  const cId = contextId == null ? activeContextId.value : contextId;

  const newGroupId = generateRandomId();
  const update = { groups: {} };
  update.groups[newGroupId] = { id: newGroupId, name };
  updateContext({ contextId: cId, update });
  return newGroupId;
};

export const addTeammate = async ({ newTeammateData, domainId }) => {
  const domain = contextsModule.doc(domainId).data;
  const authorIds = Object.keys(domain.authors);
  authorIds.push(newTeammateData.id);
  const update = { authors: {}, authorIds };
  update.authors[newTeammateData.id] = newTeammateData;
  //  Make a new panel
  const newPageId = await addPage({
    contextId: domainId,
    title: newTeammateData.name || 'new user panel',
    noWait: true
  });

  update.userPanels = {};
  update.userPanels[newTeammateData.id] = newPageId;
  console.log('update', update);
  updateContext({ update, contextId: domainId });
};

export const removeAuthor = ({ domainId, authorId }) => {
  const domainModule = contextsModule.doc(domainId);
  const domain = domainModule.data;
  const oldAuthorIds = Object.keys(domain.authors);
  const authorIds = oldAuthorIds.filter(a => a !== authorId);
  const update = {};
  update.authorIds = authorIds;
  updateContext({ contextId: domainId, update });
  domainModule.deleteProp(`authors.${authorId}`);
  domainModule.deleteProp(`userPanels.${authorId}`);
};

export const removeContext = domainId => {
  updateContext({ contextId: domainId, update: { version: 1 } });
};

export const hideDomain = domainId => {
  const userId = currentUserId.value;
  const domain = contextsModule.doc(domainId).data;
  const hideForUsers = new Set(domain.hideForUsers || []);
  hideForUsers.add(userId);
  updateContext({ contextId: domainId, update: { hideForUsers: [...hideForUsers] } });
};

export const unhideDomain = domainId => {
  const userId = currentUserId.value;
  const domain = contextsModule.doc(domainId).data;
  const hideForUsers = new Set(domain.hideForUsers || []);
  hideForUsers.delete(userId);
  updateContext({ contextId: domainId, update: { hideForUsers: [...hideForUsers] } });
};

export const createNewContext = async ({
  text = 'Untitled Context',
  basePage = false,
  template
}) => {
  console.log('creating new context');
  //get necessary items throw an error if not provided
  let localText = text;
  //get userId and throw an error if there are any problems getting the user ID

  const userId = currentUserId.value;
  //add members to user profile
  const userProfile = userModule.value.data.profile;
  userProfile.id = userId;

  let usedOn = [];

  //setup context permissions
  let contextPermissions = undefined;

  //  todo get authors from previous context if exists
  // if (fromContext) {
  //   contextPermissions = fromContext.permissions;
  //   usedOn.push(fromContextId);
  //   if (!folderId) {
  //     //  get the fromContext workspace folder;
  //     if (fromContextFolder) {
  //       saveFolder = fromContextFolder.id;
  //     } else {
  //       saveFolder = workspaceId;
  //     }
  //   }
  // } else
  contextPermissions = {
    visibility: 'private',
    editing: [],
    viewing: [],
    commenting: [],
    voting: []
  };
  contextPermissions.owner = userId;
  const contextId = generateRandomId();
  let pageId;
  if (!basePage) {
    pageId = await addPage({
      contextId,
      template: false,
      order: 0,
      title: localText,
      noWait: true
    });
  } else {
    pageId = basePage;
  }

  //  TEMPLATE ITERATOR
  if (template) {
    //  template should be an object
    //  { title, type, children: [{...}] }
    const makeTemplatePage = async (pageId, tData, order) => {
      const tPageId = await addNote({
        pageId,
        pageType: tData.type,
        html: tData.htmlTitle,
        flair: tData.flair,
        order,
        returnPageId: true
      });
      if (tData.children) {
        tData.children.forEach((child, index) => {
          makeTemplatePage(tPageId, child, index);
        });
      }
    };
    template.forEach((t, index) => {
      makeTemplatePage(pageId, t, index);
    });
  }
  const userPanels = {};
  userPanels[userId] = pageId;
  const newContextData = {
    authors: {},
    createdBy: userId,
    createdOn: new Date(),
    updated_at: new Date(),
    new: true,
    text: localText,
    id: contextId,
    permissions: contextPermissions,
    usedOn,
    basePage: pageId,
    version: 2,
    userPanels,
    flair: {},
    recentlyModified: {
      bool: true,
      initialUpdate: Date.now()
    }
  };
  newContextData.authors[userId] = userProfile;

  //update userSummary
  // const { addContext } = useUserSummary();
  // const summaryData = {
  //   id: newContextData.id,
  //   text: newContextData.text,
  //   authorIds: Object.values(newContextData.authors).map(a => a.id),
  //   folderId,
  //   lastEdited: newContextData.createdOn,
  //   lastOpened: newContextData.createdOn,
  //   imgUrl: null,
  //   isOwner: true,
  //   isPublic: false,
  //   keywords: [],
  //   newContent: false,
  //   status: 'active'
  // };

  // await addContext(summaryData);

  // console.log('newContextData', newContextData);
  //create a new context
  console.log(newContextData);
  await contextsModule.doc(contextId).insert(newContextData);

  //return the Id
  console.log(contextId);
  return contextId;
};
